import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// `inView` (default true) reveals on scroll — the site-wide behaviour. Set it
// false for lists whose children change after mount (e.g. a filtered grid):
// `whileInView` + `once` stops propagating "show" to items that mount later,
// leaving them stuck at opacity 0. `animate` keeps re-applying "show" so
// freshly-filtered items always appear.
export const Stagger = ({ children, className = "", inView = true }) => (
  <motion.div
    className={className}
    initial="hidden"
    {...(inView
      ? { whileInView: "show", viewport: { once: true, margin: "-60px" } }
      : { animate: "show" })}
    variants={{ show: { transition: { staggerChildren: 0.08 } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 24 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
    }}
  >
    {children}
  </motion.div>
);
